
import React, {
  useEffect,
  useRef,
  useState,
} from "react";

import PropTypes from "prop-types";

import {
  CustomContainer,
} from "components/atoms/DependencyHelper";
import DealCard from "components/molecules/dealCard/DealCard";

import {
  checkIsOutOfStock,
  getHighlights,
  getPromotionVariant,
  getProductImageUrl,
  imagePrefix,
} from "utils/helperServices";
import { useScreenType } from "utils/hooks/common";
import { debounce } from "utils/helperServices";

import styles from "./DealListCarousel.module.scss";

import labels from "../../../config/labels";
import { ScreenSizeTypes } from "../../../config/constants";

const ScrollByVal = 300;
const ScrollOffset = 10;

const DealListCarousel = (props) => {
  const dealContainerRef = useRef(null);

  const isTablet = useScreenType() === ScreenSizeTypes.Tablet;
  const [hScroll, setHScroll] = useState(0);
  const [maxScrollWidth, setMaxScrollWidth] = useState(ScrollByVal);

  const handleLeftScroll = () => {
    dealContainerRef?.current?.scrollBy((ScrollByVal * -1 ), 0)
  }

  const handleRightScroll = () => {
    dealContainerRef?.current?.scrollBy(ScrollByVal, 0)
  }

  useEffect(() => {
    if (!dealContainerRef?.current) {
      return;
    }
    
    const handleScroll = () => {
      const el = dealContainerRef.current;
      setHScroll(el.scrollLeft);
    };

    const element = dealContainerRef.current;
    const maxScroll = element.scrollWidth - element.clientWidth;

    if (maxScroll !== maxScrollWidth) {
      setMaxScrollWidth(element.scrollWidth - element.clientWidth);
    }

    element.addEventListener("scroll", debounce(handleScroll, 100));    

    return () => {
      element.removeEventListener("scroll", debounce(handleScroll, 100));
    };
  }, []);

  useEffect(() => {
    if (!dealContainerRef?.current) {
      return;
    }
    
    const element = dealContainerRef.current;
    const maxScroll = element.scrollWidth - element.clientWidth;

    if (maxScroll !== maxScrollWidth) {
      setMaxScrollWidth(element.scrollWidth - element.clientWidth);
    }
  }, [dealContainerRef?.current]);

  return (
    <CustomContainer className={styles["tab-content"]}>
        { hScroll > ScrollOffset && (
          <CustomContainer className={styles["carousel-arrow--left"]}>
            <span onClick={handleLeftScroll}>
              <img
                className={styles["carousel-arrow-icon"]}
                src={`${imagePrefix}/assets/images/chevron-left-black.svg`}
                alt="carousel arrow left"
              />
            </span>
          </CustomContainer>
        )}

        <CustomContainer className={styles["deals-wrapper"]}>
          <CustomContainer ref={dealContainerRef} className={`d-flex mb-5 pl-lg-0 ${styles["deals-container"]}`}>
            {props.dealList.map((item, i) =>
              item && (
                <CustomContainer
                  className={`d-flex mr-s ${i == props.dealList.length - 1 ? "pr-xs" : "" } ${styles["deal"]}`}
                  key={i}
                >
                  <DealCard
                    width={ isTablet ? "17.5rem" : "19rem"
                    }
                    width_mobile= "17.5rem"
                    height="32.938rem"
                    img_width="10rem"
                    maxHeight="33.5rem"
                    img_height="10rem"
                    height_mobile="29.313rem"
                    img_width_mobile="7.5rem"
                    img_height_mobile="7.5rem"
                    isOutOfStock={checkIsOutOfStock(item)}
                    productName={item.name}
                    imgUrl={getProductImageUrl(item, "image", "No_image")}
                    imgUrl_mobile={getProductImageUrl(item, "small_image", "No_image_1")}
                    saveLabel={ item.save_monthly_recurring }
                    promotionLabel={item?.promotion_tag != null && item?.promotion_tag_label ? item?.promotion_tag_label : ''}
                    promotionVariant={getPromotionVariant(item)}
                    promotionLabelColor={item.promotion_tag_swatch}
                    planName={item.package_description ? item.package_description: ''}
                    highlights={getHighlights(item)}
                    originalPrice={
                      !item.old_monthly_recurring ? item.monthly_recurring : null
                    }
                    offerPrice={
                      item.old_monthly_recurring ? item.monthly_recurring : null
                    }
                    prevPrice={ item.old_monthly_recurring}
                    numberOfMonths={item.payment_terms_label}
                    buttonText={labels.deal_details.lbl_get_this_deal}
                    deal_end_date={item.deal_end_date}
                    deal_go_live_date={item.deal_go_live_date}
                    deal_label={item.deal_label}
                    is_deal_locked={item.is_deal_locked}
                    buttonHandler={() => props.onSeeDetailsClick(item)}
                    noLazyload= {true}
                  />
                </CustomContainer>
              )
            )}

            <CustomContainer key={"scroll-end-padding"} />
          </CustomContainer>
        </CustomContainer>

        { hScroll < (maxScrollWidth - ScrollOffset) && (
          <CustomContainer className={styles["carousel-arrow--right"]}>
            <span onClick={handleRightScroll}>
              <img
                className={styles["carousel-arrow-icon"]}
                src={`${imagePrefix}/assets/images/chevron-right-black.svg`}
                alt="carousel arrow right"
              />
            </span>
          </CustomContainer>
        )}
      </CustomContainer>
  );
}

DealListCarousel.propTypes = {
  dealList: PropTypes.arrayOf(PropTypes.object),
  onSeeDetailsClick: PropTypes.func,
};

export default DealListCarousel;
